export default __webpack_public_path__ + "static/media/fleche rouge.87817b3b.png";